import React from "react";
import ReactDOM from "react-dom";

import Root from "./root";
import configureStore from "./store";

// CSS Reset
import '../node_modules/normalize.css/normalize.css';
import "./styles.css";

// Custom styles
import '../node_modules/@blueprintjs/core/lib/css/blueprint.css'
import '../node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css'


const store = configureStore();

const rootElement = document.getElementById("root");
ReactDOM.render(<Root store={store} />, rootElement);
